import React from 'react';
import PropTypes from 'prop-types';
import { SlideContext } from '../hooks/use-slide';

var Notes = function Notes(_ref) {
  var children = _ref.children;

  var _React$useContext = React.useContext(SlideContext),
      setNotes = _React$useContext.actions.setNotes;

  React.useEffect(function () {
    setNotes(children);
  }, [setNotes, children]);
  return null;
};

Notes.propTypes = {
  children: PropTypes.node.isRequired
};
export default Notes;